import {
  REAL_ESTATE,
  REAL_ESTATE_PROPERTIES,
  REAL_ESTATE_SOURCE
} from '@/interfaces/realEstate.interface'
import { getRequestGateway } from './api.service'
const aborter: AbortController | null = null

export async function getAllRealEstatesv1(
  cancelPendingRequest?: boolean,
  timeout?: number
): Promise<REAL_ESTATE_SOURCE> {
  try {
    const realEstates: REAL_ESTATE_SOURCE = {
      type: 'geojson',
      data: {
        id: 'all-realestates',
        type: 'FeatureCollection',
        features: []
      }
    }
    if (cancelPendingRequest && aborter) aborter.abort()
    const res = await Promise.all([
      getRequestGateway('core/v1/realestates', timeout),
      getRequestGateway('core/v1/realestates/geojson', timeout)
    ])
    const response = res[0].data as REAL_ESTATE_PROPERTIES[]
    const responseGeojson = res[1].data as REAL_ESTATE[]
    const features = response
    const featuresGeojson = responseGeojson
    featuresGeojson.forEach((realEstate: REAL_ESTATE) => {
      const feature = features.find(
        (feature: REAL_ESTATE_PROPERTIES) => feature.id === realEstate.properties.belongsToId
      )
      if (feature) {
        realEstate.properties = feature
        realEstate.id = realEstate.properties.id
        realEstate.properties.belongsToId = realEstate.properties.id
      }
    })
    realEstates.data.features = featuresGeojson
    return realEstates
  } catch (e: any) {
    console.error(e)
    throw new Error('Could not fetch real estates')
  }
}
